"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8663,7798,2968,8461],{

/***/ 37798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tag_items_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var react = __webpack_require__(12783);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/default-props.js

/* harmony default export */ var default_props = ({
    tagBackgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/tag.scss.js

var TAG_IMAGE_SIZE = "44px";
var StyledTagAnchorWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "es7hxax0"
})("text-decoration:none;color:unset;cursor:pointer;");
var StyledTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es7hxax1"
})("display:flex;flex-direction:row;justify-content:center;align-items:center;&.has-on-click-behavior{cursor:pointer;}.tag-image-wrapper{display:flex;align-items:center;justify-content:center;border-radius:50%;.tag-picture{.tag-icon{height:100%;}}}.tag-text{margin-left:8px;font-size:1.125rem;line-height:22px;font-weight:300;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/tag.js









var Tag = function(props) {
    var tagIconsrc = props.tagIconsrc, tagText = props.tagText, onClick = props.onClick, tagBackgroundColor = props.tagBackgroundColor, tagImageHeight = props.tagImageHeight, href = props.href, openInNewTab = props.openInNewTab, noImageWidth = props.noImageWidth, tagTextSize = props.tagTextSize;
    var onTagClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: tagText,
            info1: href
        });
        if (onClick) {
            onClick(tagText);
        }
    };
    var anchorWrapper = function(children) {
        var target = openInNewTab ? "_blank" : undefined;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagAnchorWrapper, {
            className: "tag-anchor-wrapper",
            href: href,
            target: target,
            children: children
        });
    };
    var tagImageSize = tagImageHeight || TAG_IMAGE_SIZE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* ConditionalWrapper */.M, {
        condition: href,
        wrapper: anchorWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTag, {
            className: classnames_default()("tag", {
                "has-on-click-behavior": onClick
            }),
            onClick: onTagClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag-image-wrapper",
                    style: {
                        backgroundColor: colors/* default */.Z[tagBackgroundColor],
                        height: tagImageSize,
                        width: !noImageWidth && tagImageSize
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        className: "tag-icon",
                        pictureClass: "tag-picture",
                        src: tagIconsrc,
                        pictureComponentHeight: tagImageSize
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag-text",
                    style: {
                        fontSize: tagTextSize
                    },
                    children: tagText
                })
            ]
        })
    });
};
/* harmony default export */ var tag = (Tag);
Tag.defaultProps = default_props;

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-component.scss.js


var StyledTagItemsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2800i00"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-wrap:wrap;justify-content:center;.grid-tag-wrapper{margin:16px 32px 16px 0;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var TagItemsGridComponent = function(props) {
    var _gridTags = props.gridTags, gridTags = _gridTags === void 0 ? [] : _gridTags, width = props.width, gridTagsBackgroundColor = props.gridTagsBackgroundColor, gridTagsImageHeight = props.gridTagsImageHeight, noImageWidth = props.noImageWidth, tagTextSize = props.tagTextSize;
    var renderTag = function(gridTag, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid-tag-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag, _object_spread_props(_object_spread({}, gridTag), {
                tagBackgroundColor: gridTagsBackgroundColor,
                tagImageHeight: gridTagsImageHeight,
                noImageWidth: noImageWidth,
                tagTextSize: tagTextSize
            }))
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagItemsGridComponent, {
        className: "tag-items-grid-component",
        style: {
            width: width
        },
        children: gridTags.map(renderTag)
    });
};
TagItemsGridComponent.defaultProps = {
    paddingTop: "16px",
    paddingBottom: "16px",
    gridTags: [
        {
            tagText: "Projects",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Projects_icon_circle.png"
        },
        {
            tagText: "Marketing",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png"
        },
        {
            tagText: "CRM",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/CRM_icon_circle.png"
        },
        {
            tagText: "Software",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/software_icon_circle.png"
        },
        {
            tagText: "Creative & design",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Creative_design_icon_circle.png"
        },
        {
            tagText: "HR",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/HR_icon_circle.png"
        },
        {
            tagText: "Operations",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Operations_icon_circle.png"
        },
        {
            tagText: "IT",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/IT_icon_circle.png"
        },
        {
            tagText: "200+ workflows",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/200_workflows_icon_circle.png"
        }
    ]
};
/* harmony default export */ var tag_items_grid_component = (TagItemsGridComponent);


/***/ }),

/***/ 98461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FullParagraphComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.scss.js



var StyledFullParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej9vftf0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.full-paragraph-wrapper{max-width:1100px;margin:auto;display:flex;justify-content:center;padding:0px ", full_paragraph/* PARAGRAPH_HORIZONTAL_PADDING_STRING */.xe, ";}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FullParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullParagraphComponent);
    function FullParagraphComponent() {
        (0,_class_call_check/* default */.Z)(this, FullParagraphComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FullParagraphComponent, [
        {
            key: "render",
            value: function render() {
                var maxWidth = this.props.maxWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFullParagraphComponent, {
                    className: "full-paragraph-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "full-paragraph-wrapper",
                        style: {
                            maxWidth: maxWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return FullParagraphComponent;
}(react.PureComponent);

FullParagraphComponent.defaultProps = _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.MD,
    textSize: sizes.MD,
    maxWidth: "1100px"
});


/***/ }),

/***/ 88663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ personas_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js + 1 modules
var two_thirds_text_and_asset_component = __webpack_require__(32968);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.js + 1 modules
var full_paragraph_component = __webpack_require__(98461);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-component.js + 4 modules
var tag_items_grid_component = __webpack_require__(37798);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component.js + 5 modules
var flexible_cards_grid_component = __webpack_require__(38885);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config.js
var flexible_cards_grid_config = __webpack_require__(73767);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props.js
var default_props = __webpack_require__(427);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var getGridImageWithParagraphProps = function(imageSrc, fullParagraphTitle, fullParagraphBody) {
    var fullParagraph = _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody,
        textAlign: "center",
        mobileTextAlign: "center"
    });
    return _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        mobileImage: {
            src: imageSrc
        },
        fullParagraph: fullParagraph,
        cardNumOfColumnsWidth: 4
    });
};
/* harmony default export */ var personas_tabs_default_props = (_object_spread_props(_object_spread({}, tabs_component/* default.defaultProps */.Z.defaultProps), {
    tabsColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
    swapTagsWithTextAndAssets: false,
    tabs: [
        {
            tabLabel: "Business owner",
            textAndAssetTwoThirds: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
                fullParagraph: _object_spread({}, default_props/* default.fullParagraph */.Z.fullParagraph),
                asset: _object_spread_props(_object_spread({}, default_props/* default.asset */.Z.asset), {
                    position: "center"
                })
            }),
            fullParagraph: _object_spread_props(_object_spread({}, full_paragraph_component["default"].defaultProps), {
                topic: {},
                title: "Why use monday CRM",
                body: "",
                textAlign: "center",
                mobileTextAlign: "center"
            }),
            tagItems: _object_spread_props(_object_spread({}, tag_items_grid_component["default"].defaultProps), {
                gridTagsBackgroundColor: "transparent"
            }),
            flexibleCards: _object_spread_props(_object_spread({}, flexible_cards_grid_config/* default.defaultProps */.Z.defaultProps), {
                imagePaddingBottom: "24px",
                gridItems: [
                    getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/SafaaEek/467px-Monday_logo.svg.png", "“I like the ease of use and the ability to do everything from one main dashboard, as well as the ease of adding automations.", "Maurice W. | CEO, facilities services ")
                ]
            })
        },
        {
            tabLabel: "Sales Manager",
            textAndAssetTwoThirds: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
                fullParagraph: _object_spread({}, default_props/* default.fullParagraph */.Z.fullParagraph),
                asset: _object_spread_props(_object_spread({}, default_props/* default.asset */.Z.asset), {
                    position: "center"
                })
            }),
            fullParagraph: _object_spread_props(_object_spread({}, full_paragraph_component["default"].defaultProps), {
                topic: {},
                title: "Why use monday CRM",
                body: "",
                textAlign: "center",
                mobileTextAlign: "center"
            }),
            tagItems: _object_spread_props(_object_spread({}, tag_items_grid_component["default"].defaultProps), {
                gridTagsBackgroundColor: "transparent"
            }),
            flexibleCards: _object_spread_props(_object_spread({}, flexible_cards_grid_config/* default.defaultProps */.Z.defaultProps), {
                imagePaddingBottom: "24px",
                gridItems: [
                    getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/SafaaEek/467px-Monday_logo.svg.png", "“I like the ease of use and the ability to do everything from one main dashboard, as well as the ease of adding automations.", "Maurice W. | CEO, facilities services ")
                ]
            })
        }
    ]
}));

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/personas-tabs-component.scss.js




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var StyledPersonasTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1176lfk0"
})("margin:0 auto;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}.personas-tabs-component{padding:48px;background-color:var(--tab-background-color);border-radius:16px;.tabs{border-bottom:var(--tab-underline-color) solid;//  makes the undeline under the tab names combined.\n      border-bottom-width:2px;.tab-component{background-color:transparent;// no background to tab name\n        min-width:0;.tab-underline-placeholder{background-color:transparent;}.tab-label{font-weight:300;font-size:1.25rem;}:hover{outline:0;background-color:", colors/* default.white-iris */.Z["white-iris"], ";border-radius:8px 8px 0px 0px;.tab-label{color:", colors/* default.mud */.Z.mud, ";}}&.active{background-color:transparent;.tab-label{font-weight:600;}}}}.two-thirds-text-and-asset-component{padding-top:var(--text-and-asset-padding-top);}.side-by-side-content{background-color:transparent !important;}.full-paragraph-component{padding-top:var(--full-paragraph-padding-top);}.tag-items-grid-component{padding-top:var(--tag-items-padding-top);.grid-tag-wrapper{margin:0px 32px 0px 0;}}.flexible-cards-grid-desktop-component{padding-top:var(--flexible-cards-padding-top);.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{width:100%;}}}.grid-paragraph-with-image{display:flex;align-items:center;.grid-image{padding-bottom:var(--flexible-cards-padding-bottom);}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/personas-tabs-component.js
function personas_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function personas_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            personas_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}











var PersonasTabsComponent = function(props) {
    var DEFAULT_PADDING_TOP = "24px";
    var tabs = props.tabs, tabsColor = props.tabsColor, tabsBackgroundColor = props.tabsBackgroundColor, alignToLogo = props.alignToLogo, swapTagsWithTextAndAssets = props.swapTagsWithTextAndAssets, theme = props.theme;
    var componentsRenderer = function(fullParagraph, tagItems, textAndAssetTwoThirds, flexibleCards) {
        if (swapTagsWithTextAndAssets) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph_component["default"], personas_tabs_component_object_spread({}, fullParagraph)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_items_grid_component["default"], personas_tabs_component_object_spread({}, tagItems)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(two_thirds_text_and_asset_component["default"], personas_tabs_component_object_spread({}, textAndAssetTwoThirds)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flexible_cards_grid_component["default"], personas_tabs_component_object_spread({}, flexibleCards))
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(two_thirds_text_and_asset_component["default"], personas_tabs_component_object_spread({}, textAndAssetTwoThirds)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph_component["default"], personas_tabs_component_object_spread({}, fullParagraph)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_items_grid_component["default"], personas_tabs_component_object_spread({}, tagItems)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flexible_cards_grid_component["default"], personas_tabs_component_object_spread({}, flexibleCards))
            ]
        });
    };
    var tabsRenderer = function() {
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, _textAndAssetTwoThirds = tab.textAndAssetTwoThirds, textAndAssetTwoThirds = _textAndAssetTwoThirds === void 0 ? {} : _textAndAssetTwoThirds, _fullParagraph = tab.fullParagraph, fullParagraph = _fullParagraph === void 0 ? {} : _fullParagraph, _tagItems = tab.tagItems, tagItems = _tagItems === void 0 ? {} : _tagItems, _flexibleCards = tab.flexibleCards, flexibleCards = _flexibleCards === void 0 ? {} : _flexibleCards, tabId = tab.tabId;
            var textAndAssetPaddingTop = textAndAssetTwoThirds.textAndAssetPaddingTop;
            var fullParagraphPaddingTop = fullParagraph.fullParagraphPaddingTop;
            var tagItemsPaddingTop = tagItems.tagItemsPaddingTop;
            var flexibleCardsPaddingTop = flexibleCards.flexibleCardsPaddingTop, imagePaddingBottom = flexibleCards.imagePaddingBottom;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                className: "tab-component-container",
                tabId: tabId,
                label: tabLabel,
                color: tabsColor,
                theme: theme,
                unsetLabelColor: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "components-container",
                    style: {
                        "--text-and-asset-padding-top": textAndAssetPaddingTop || DEFAULT_PADDING_TOP,
                        "--full-paragraph-padding-top": fullParagraphPaddingTop || DEFAULT_PADDING_TOP,
                        "--tag-items-padding-top": tagItemsPaddingTop || DEFAULT_PADDING_TOP,
                        "--flexible-cards-padding-top": flexibleCardsPaddingTop || DEFAULT_PADDING_TOP,
                        "--flexible-cards-padding-bottom": imagePaddingBottom
                    },
                    children: componentsRenderer(fullParagraph, tagItems, textAndAssetTwoThirds, flexibleCards)
                })
            }, index);
        });
    };
    var backgroundColor = colors/* default */.Z[tabsBackgroundColor];
    var underlineColor = colors/* default */.Z[tabsColor];
    var autoTransition = props.autoTransition, scrollOnTabClick = props.scrollOnTabClick, scrollSpeed = props.scrollSpeed, distanceFromTop = props.distanceFromTop, activeTabId = props.activeTabId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPersonasTabsComponent, {
        className: classnames_default()("personas-tabs-component-container", {
            "align-to-logo": alignToLogo
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "personas-tabs-component",
            style: {
                "--tab-background-color": backgroundColor,
                "--tab-underline-color": underlineColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
                autoTransition: autoTransition,
                scrollOnTabClick: scrollOnTabClick,
                scrollSpeed: scrollSpeed,
                distanceFromTop: distanceFromTop,
                activeTabId: activeTabId,
                role: "tabpanel",
                children: tabsRenderer()
            })
        })
    });
};
PersonasTabsComponent.defaultProps = personas_tabs_default_props;
/* harmony default export */ var personas_tabs_component = (PersonasTabsComponent);


/***/ }),

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38305);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    fullParagraph: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].fullParagraph */ .Z.fullParagraph), {
        topic: {
            text: "For the creative process",
            color: "brand-blue"
        },
        title: "Streamline your creative workflow",
        body: "Use customizable forms to request all the information needed. Then, easily share assets and receive feedback in real time."
    }),
    asset: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset */ .Z.asset), {
        image: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset.image */ .Z.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
        })
    })
}));


/***/ }),

/***/ 32968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TwoThirdsTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.scss.js

var StyledTwoThirdsTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emxkgw60"
})(".side-by-side-text-and-asset-component{.side-by-side-content{.full-paragraph-component-wrapper{width:40%;}.image-wrapper{width:60%;}&.no-text-component{justify-content:center;.image-wrapper{width:100%;}}}}");

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props.js
var default_props = __webpack_require__(427);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var TwoThirdsTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoThirdsTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoThirdsTextAndAssetComponent);
    function TwoThirdsTextAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, TwoThirdsTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoThirdsTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoThirdsTextAndAssetComponent, {
                    className: "two-thirds-text-and-asset-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], _object_spread({}, this.props))
                });
            }
        }
    ]);
    return TwoThirdsTextAndAssetComponent;
}(react.PureComponent);

TwoThirdsTextAndAssetComponent.defaultProps = default_props/* default */.Z;


/***/ })

}]);